import * as React from "react"
import { isEmpty as _isEmpty } from "lodash"
import {MultiModalComponent} from "./ModalComponent";

interface IIssueModalProps {
    icon: string,
    title: string,
    body: string,
    actions?: any
}

const IssueModal = (props: IIssueModalProps) => {
    return (
        <div className={"issue-modal"}>
            <div className={"icon-container"}>
                <img src={props.icon} />
            </div>
            <div className={"issue-body"}>
                <p className={"issue-title brandon-bold"}>{props.title}</p>
                <p className={"issue-desc"}>{props.body}</p>
                {props.actions && <div className={"action-container"}></div>}
            </div>
        </div>
    )
}

const CheckMediaDevices = () => {
    const [show, toggleShow] = React.useState(false)
    const [issueModals, setIssueModals] = React.useState([])
    React.useEffect(() => {
        (async function() {
            let issues: {title: string, body: string, iconPath: string}[] = []
            try {
                await navigator.mediaDevices.getUserMedia({audio: true})
            } catch (e) {
                issues.push({
                    title: "Microphone access needed",
                    body: "We need access to your microphone for video calls. Please permit orion.curefit.co to access your mic by clicking on the icon in your address bar and then refresh the page.",
                    iconPath: "/images/audio-mic.svg"
                })
            }
            try {
                await navigator.mediaDevices.getUserMedia({video: true})
            } catch (e) {
                issues.push({
                    title: "Camera access needed",
                    body: "We need access to your camera for video calls. Please permit orion.curefit.co to access your camera, by clicking on the icon in your address bar and then refresh the page.",
                    iconPath: "/images/video-pink.svg"
                })
            }
            if (!_isEmpty(issues)) {
                setIssueModals(issues)
                toggleShow(true)
            }
        })()
    }, [])
    if (!show) return null
    const modalComponents = issueModals.map(issue => <IssueModal icon={issue.iconPath} title={issue.title} body={issue.body}/>)
    return <MultiModalComponent
        isActive={show}
        modalSize={"x-small"}
        className={"check-media-device-modal"}
        components={modalComponents}/>
}

export default CheckMediaDevices